import React from 'react';
import Text from 'components/Core/Text';
import HyperLink from 'components/Core/HyperLink';
import Banner from '..';
import { Container } from './styles';
import Tooltip from 'components/Core/Tooltip';
import Icon from 'components/Icon';

const AnnouncementBar = ({
  copy,
  customPhoneNumber,
  hideSignIn,
  linkTitle,
  linkUrl,
  showAdditionalMenuItems,
  theme,
}) => {
  const darkTheme = theme === 'TRANS_BG_BLACK_COLOR' || theme === 'WHITE_BG_BLACK_COLOR';
  const includesLink = linkUrl && linkTitle;
  const includesCopyOrLink = copy || includesLink;

  return (
    <Banner className="website-header--announcement-bar min-xl">
      <Container isBlack={darkTheme}>
        <div>
          {includesCopyOrLink && (
            <Text type="p" size="normal">
              {copy}
              {includesLink && (
                <>
                  {': '}
                  <HyperLink
                    href={linkUrl || '/tools/roi-calculator'}
                    ctaPosition="announcementbar roi calculator"
                    className="announcement-bar--link"
                  >
                    {linkTitle}
                  </HyperLink>
                </>
              )}
            </Text>
          )}
        </div>
        <div className="announcement-bar-right gap-[10px]">
          <>
            {showAdditionalMenuItems?.includes('Phone Number') && (
              <>
                <Tooltip
                  placement="top"
                  title={customPhoneNumber || '(855) 899-0970'}
                  tooltipStyle={{ maxWidth: 500, fontSize: 'var(--font-size-p)', padding: 25 }}
                >
                  <HyperLink
                    data-position="Header - Menu Item CTA"
                    className="font-h6 header-phone-num"
                    ctaPosition="phonenumber"
                    href={`tel: ${customPhoneNumber || '(855) 899-0970'}`}
                  >
                    <Icon id="phone" className="announcement-bar--icon phone-icon" />
                  </HyperLink>
                </Tooltip>
                <div
                  className={`divider h-[27px] w-[1px] ${darkTheme ? 'bg-black' : 'bg-white'}`}
                />
              </>
            )}
            <Text type="p" size="normal">
              <HyperLink
                href="https://www.servicetitan.com/customer-resource-hub"
                ctaPosition="customer resource hub"
              >
                <strong>Customer Resource Hub</strong>
              </HyperLink>
            </Text>
            {!hideSignIn && (
              <>
                <div
                  className={`divider h-[27px] w-[1px] ${darkTheme ? 'bg-black' : 'bg-white'}`}
                />
                <Text type="p" size="normal">
                  <HyperLink
                    href="https://go.servicetitan.com/auth/externallogin"
                    ctaPosition="announcementbar signin"
                    target="_blank"
                  >
                    <strong>Sign In</strong>
                    <Icon id="sign-in" className="announcement-bar--icon" />
                  </HyperLink>
                </Text>
              </>
            )}
          </>
        </div>
      </Container>
    </Banner>
  );
};

export default AnnouncementBar;
